export type CSVColumn = {
  key: string;
  label: string;
};

export const CSV_COLUMNS: CSVColumn[] = [
  { key: "wo", label: "Work Order" },
  { key: "division", label: "Division" },
  { key: "call_type", label: "Call Type" },
  { key: "assigned_to", label: "Assigned To" },
  { key: "machine", label: "Machine"},
  { key: "machine_location", label: "Machine Location" },
  { key: "customer", label: "Customer" },
  { key: "status", label: "Status" },
  { key: "description", label: "Description" },
  { key: "created_at", label: "Created At" },
  { key: "scheduled_service_date", label: "Scheduled Service Date" }
];